import { gql } from '@apollo/client';
export const FIELD_OPTION = gql `
  query FIELD_OPTION($spec: LookupSpec!) {
    fieldOption(spec: $spec) {
      name
      code
      type
      isRequired
      isActive
      options {
        items {
          value
          label
          localize
          params
        }
        page
        pageSize
        total
      }
    }
  }
`;
export const LOOKUP_OPTIONS = gql `
  query LOOKUP_OPTIONS($spec: LookupSpec!) {
    lookupOptions(spec: $spec) {
      items {
        value
        label
        localize
        params
      }
      page
      pageSize
      total
    }
  }
`;
